import gql from 'graphql-tag';
import { TAG_DETAILS_FRAGMENT } from './fragments';

const createTagMutation = gql`
  mutation CreateTag($input: CreateTagInput!) {
    createTag(input: $input) {
      ...TagDetails
    }
  }
  ${TAG_DETAILS_FRAGMENT}
`;

export default ((organisationId) => ({
  mutation: createTagMutation,
  module: 'tags',
  isSilent: true,
  buildVariables: ({ label, color }) => ({
    input: {
      organisationId,
      tagType: 'WORKSPACE',
      resourceType: 'ASSET',
      label,
      ...(color ? { color } : {})
    }
  })
}));